import Image from 'app/Components/Shared/Image/image';
import React, {useState} from 'react';
import {UncontrolledTooltip} from 'reactstrap';

const Tooltip = (props) => {
  const { cellcomdefault, title, text, target, placement, offsetRight, showCloseButton, onClose, additionalClassName, ...restProps  } = props;

  const modifiers = offsetRight ? {
    offset: {
      enabled: true,
      offset: `${offsetRight}, 0`
    }
  } : undefined;

  const tooltipClassName = `${cellcomdefault === true ? 'cellcom-tooltip ' : ''}${offsetRight ? 'cellcom-tooltip-offset-right ' : ''}${showCloseButton ? 'cellcom-tooltip-closable ' : ''}${additionalClassName ? `${additionalClassName} ` : ''}${target}`;

  const handleClose = (e) => {
    e.stopPropagation();
    if (onClose) {
      onClose();
    }else{
      document.getElementById(target).classList.remove('show');
    }
  };

  return (
    <UncontrolledTooltip
      className={tooltipClassName}
      placement={placement}
      target={target}
      modifiers={modifiers}
      {...restProps}>
      <div className="tooltip-content-wrapper">
        {showCloseButton && (
          <div className="tooltip-close-button-wrapper">
          <a href="#" role="button" className="tooltip-close-button" onClick={handleClose} type="button">
            <Image src={require('./icons/close.png')} alt="close" />
          </a>
          </div>
        )}
        {title && <div dangerouslySetInnerHTML={{__html: title}} className={'tooltip-title'} />}
        <div className='tooltip-text' dangerouslySetInnerHTML={{ __html: (props.text || '').replace(/\n/g, '<br />') }} />
      </div>
    </UncontrolledTooltip>
  );
};
export default Tooltip;
